// This file should only contain action type constants.

export const SET_PII = 'SET_PII';
export const SET_DL_ITEMS = 'SET_DL_ITEMS';
